export const MAX_FEE_CENTS = 1000000; // $10,000

export const FEE_TYPES = [
  {
    fee_type: "administration_fee" as const,
    label: "Collect Administration Fee",
    description: "Paid once by the primary applicant"
  },
  {
    fee_type: "holding_fee" as const,
    label: "Collect Holding Fee",
    description: "Paid once by the primary applicant"
  }
];
